// src/components/CheckoutBoletoAsaas.js
import React, { useState } from "react";
import { motion } from "framer-motion";
import { Receipt, AlertCircle, ExternalLink, ArrowLeft, CheckCircle } from "lucide-react";
import axios from "axios";
import "../styles/checkout-boleto.css";

export default function CheckoutBoletoAsaas({ pedido, voltar }) {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    cpfCnpj: "",
  });
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");
  const [boletoUrl, setBoletoUrl] = useState("");
  const [linhaDigitavel, setLinhaDigitavel] = useState("");
  const [dueDate, setDueDate] = useState("");

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErro("");
    try {
      const token = localStorage.getItem("token");
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/pagamento/asaas/boleto`,
        {
          pedidoId: pedido._id,
          totalPedido: pedido.total,
          nomeVaqueiro: `${form.firstName} ${form.lastName}`.trim(),
          email: form.email,
          cpfCnpj: form.cpfCnpj,
          phone: pedido?.usuario?.whatsapp || "",
          descricao: `Pagamento do pedido ${pedido._id}`,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setBoletoUrl(data?.boleto_url || "");
      setLinhaDigitavel(data?.linha_digitavel || "");
      setDueDate(data?.dueDate || "");
    } catch (err) {
      console.error("Erro Asaas boleto:", err?.response?.data || err.message);
      setErro(
        err?.response?.data?.detail ||
          err?.response?.data?.error ||
          "Erro ao gerar boleto Asaas."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="ty-checkout-container"
    >
      <h2 className="ty-checkout-title">Pagamento via Boleto</h2>

      {erro && (
        <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} className="ty-checkout-erro">
          <AlertCircle size={18} />
          {erro}
        </motion.div>
      )}

      {boletoUrl ? (
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="ty-boleto-gerado">
          <div className="ty-boleto-sucesso">
            <CheckCircle size={50} className="ty-success-icon" />
            <h3>Sua compra foi registrada no nosso sistema!</h3>
          </div>

          <div className="ty-success-message">
            {dueDate && (
   <p>
     <strong>Vencimento:</strong>{" "}
     {(() => {
       const [y, m, d] = (dueDate || "").split("-");
       return d && m && y ? `${d}/${m}/${y}` : dueDate;
     })()}
   </p>
 )}
            {linhaDigitavel && <p><strong>Linha digitável:</strong> {linhaDigitavel}</p>}
            <p>Vamos aguardar a confirmação do pagamento pelo banco.</p>
            <p>Compras com boleto podem demorar até 3 dias.</p>
            <p>Mas fique tranquilo, a confirmação é automática.</p>
          </div>

          <div className="ty-boleto-info">
            <Receipt size={24} className="ty-boleto-icon" />
            <p>Clique no botão abaixo para visualizar e imprimir seu boleto.</p>
          </div>

          <motion.a
            href={boletoUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="ty-btn-visualizar-boleto"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <ExternalLink size={18} />
            Visualizar Boleto
          </motion.a>

          <motion.button
            onClick={voltar}
            className="ty-btn-voltar"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
          >
            <ArrowLeft size={18} />
            Voltar
          </motion.button>
        </motion.div>
      ) : (
        <form onSubmit={handleSubmit} className="ty-boleto-form">
          <div className="ty-form-grid">
            <div className="ty-form-group">
              <label htmlFor="firstName">Nome</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={form.firstName}
                onChange={onChange}
                placeholder="Seu nome"
                required
              />
            </div>

            <div className="ty-form-group">
              <label htmlFor="lastName">Sobrenome</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={form.lastName}
                onChange={onChange}
                placeholder="Seu sobrenome"
                required
              />
            </div>
          </div>

          <div className="ty-form-group">
            <label htmlFor="email">E-mail</label>
            <input
              type="email"
              id="email"
              name="email"
              value={form.email}
              onChange={onChange}
              placeholder="Seu e-mail"
              required
            />
          </div>

          <div className="ty-form-group">
            <label htmlFor="cpfCnpj">CPF/CNPJ</label>
            <input
              type="text"
              id="cpfCnpj"
              name="cpfCnpj"
              value={form.cpfCnpj}
              onChange={onChange}
              placeholder="Somente números"
              required
            />
          </div>

          <div className="ty-form-actions">
            <motion.button
              type="button"
              onClick={voltar}
              className="ty-btn-cancelar"
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
            >
              <ArrowLeft size={18} />
              Voltar
            </motion.button>

            <motion.button
              type="submit"
              className="ty-btn-gerar-boleto"
              disabled={loading}
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
            >
              {loading ? (
                <>
                  <div className="ty-button-loader"></div>
                  Gerando Boleto...
                </>
              ) : (
                <>
                  <Receipt size={18} />
                  Gerar Boleto
                </>
              )}
            </motion.button>
          </div>
        </form>
      )}
    </motion.div>
  );
}
